<template>
  <div class="settlement-apply-detail-title">
    <div class="f-16 c3">采购方：{{ data.buyerOrgName }}</div>
    <div class="f-14 c3 m-t20 flex-h-sb">
      <span>订单数量：{{ data.orderNum }}</span>
      <span>提单数量：{{ data.pickNum }}</span>
      <span
        >实提数量/重量：{{ data.totalActualQuantity }}件/{{
          data.totalActualWeight | formatWeight
        }}吨</span
      >
      <span>待结算金额：{{ data.totalSettleAmount | formatPermil }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplyDetailTitle',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
.settlement-apply-detail-title {
  background: #f8f8f8;
  padding: 25px;
}
</style>
